"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var math_expression_evaluator_1 = (0, tslib_1.__importDefault)(require("math-expression-evaluator"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var colors_1 = require("../../../../theme/colors");
function InputControl(_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? '0.00' : _b, value = _a.value, testId = _a.testId, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, className = _a.className, readOnly = _a.readOnly, onClick = _a.onClick, _c = _a.isEditable, isEditable = _c === void 0 ? false : _c, _d = _a.textAlign, textAlign = _d === void 0 ? 'right' : _d, _e = _a.width, width = _e === void 0 ? 80 : _e, _f = _a.isString, isString = _f === void 0 ? false : _f;
    var normalizedValue = typeof value === 'string' || typeof value === 'number' ? value : '0';
    return readOnly ? (react_1.default.createElement(StyledInputControl, { textAlign: textAlign, width: width, isEditable: isEditable, onClick: onClick, readOnly: readOnly, "data-testid": testId, className: className, placeholder: placeholder, value: String(normalizedValue), onFocus: function (e) {
            e.target.setSelectionRange(0, e.target.value.length);
            if (onFocus) {
                onFocus(e);
            }
        }, onBlur: function (e) {
            var val;
            try {
                if (isString) {
                    val = e.target.value;
                }
                else {
                    var stripTargetValue = e.target.value.replace(/,/g, '');
                    val = math_expression_evaluator_1.default.eval(stripTargetValue);
                }
                if (onChange) {
                    onChange(val);
                }
            }
            catch (err) {
                if (onChange) {
                    onChange(null);
                }
            }
            if (onBlur) {
                onBlur(e);
            }
        } })) : (react_1.default.createElement(StyledInputControl, { textAlign: textAlign, width: width, isEditable: isEditable, onClick: onClick, readOnly: readOnly, "data-testid": testId, className: className, placeholder: placeholder, defaultValue: String(normalizedValue), onFocus: function (e) {
            e.target.setSelectionRange(0, e.target.value.length);
            if (onFocus) {
                onFocus(e);
            }
        }, onBlur: function (e) {
            var val;
            try {
                if (isString) {
                    val = e.target.value;
                }
                else {
                    var stripTargetValue = e.target.value.replace(/,/g, '');
                    val = math_expression_evaluator_1.default.eval(stripTargetValue);
                }
                if (onChange) {
                    onChange(val);
                }
            }
            catch (err) {
                if (onChange) {
                    onChange(null);
                }
            }
            if (onBlur) {
                onBlur(e);
            }
        } }));
}
exports.default = InputControl;
var StyledInputControl = styled_components_1.default.input(function (_a) {
    var isEditable = _a.isEditable, textAlign = _a.textAlign, width = _a.width;
    return ({
        margin: 7,
        border: isEditable ? "1px solid ".concat(colors_1.colors.steel[200]) : '1px solid transparent',
        boxSizing: 'border-box',
        color: isEditable ? "".concat(colors_1.colors.steel[600]) : 'black',
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 'normal',
        fontSize: 14,
        height: 30,
        textAlign: textAlign === 'left' ? 'left' : 'right',
        outline: 'none',
        paddingTop: 7,
        paddingRight: 11,
        paddingBottom: 7,
        paddingLeft: 12,
        width: width,
        borderRadius: 4,
        backgroundColor: isEditable ? 'white' : 'transparent',
        focus: {
            borderColor: "".concat(colors_1.colors.steel[200]),
            boxShadow: "0 0 0 3px ".concat(colors_1.colors.steel[200], "30"),
            backgroundColor: 'white',
            color: "".concat(colors_1.colors.steel[400]),
        },
    });
});
//# sourceMappingURL=input.js.map